export default __webpack_public_path__ + "static/media/beej-black.7eec5ba0.png";